import { CustomCellRendererProps } from 'ag-grid-react';
import { Link, useLocation } from 'react-router';
import { Stack, Typography } from '@mui/material';
import {
  IFundMetricsByFund,
  IFundOverviewRow,
} from '../../../../../../../data-models/fund-metrics.data-model';
import { ROUTES } from '../../../../../../../constants/RouteNameMapping';
import { FMT } from '@foresightdata/web-common-formatter-service';
import { PermissionService } from '../../../../../../../services/PermissionService';
import { PermissionKey } from '../../../../../../../services/PermissionAndRolesKeys';

export interface IFundProfileLinkRendererProps extends CustomCellRendererProps<IFundMetricsByFund, number> {
  // Overrides the profile url built from the fund id; used as the auto group column's
  // innerRenderer, where `value` is the group column's own (already-formatted) value rather
  // than the raw fund id, so the id is read from `data` instead.
  hrefFor?: (row: IFundOverviewRow) => string;
}

export function FundProfileLinkRenderer(params: IFundProfileLinkRendererProps) {
  const permSvc = PermissionService.get();
  const location = useLocation();
  const { value, hrefFor, data } = params;
  // `value` is the auto group column's own (already-formatted) value in hrefFor mode, never a fund id.
  const fundId = hrefFor ? data?.fundId : value;
  if (!fundId) {
    return null;
  }

  const fundName = FMT.format('fund', fundId);
  if (!permSvc.hasPermission(PermissionKey.hasFundProfilesModule)) {
    return (
      <Stack direction={'row'} alignItems={'center'} height={'100%'}>
        <Typography variant='body2'>{fundName}</Typography>
      </Stack>
    );
  }
  const url = hrefFor && data ? hrefFor(data) : `/${ROUTES.FUND_PROFILES}/${fundId}`;
  return (
    <Link to={url} state={{ fromList: true, from: location.pathname }}>
      {fundName}
    </Link>
  );
}
